import React, { Component, forwardRef } from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { connect } from 'react-redux';
import DropdownSelect from './ProposalGenerator/DropdownSelect';
import { addCompanyChange } from '../actions/Companies';
import TemplateAutoComplete from './TemplateAutocomplete';
import { getTemplates } from '../actions/ModifyProducts';
import { STATE_OPTIONS } from '../utils/constants';
import Toggle from './Toggle';
import MultiInput from './MultiInput';
import util from '../lib/utils';
import { COMPANY_TYPE_DROPDOWN } from '../lib/constants';
import Location from '../components/Location/index'
import AlertFaxDownloadModal from './AlertFaxDownloadModal';
import { COMPANY_MODAL } from '../lib/constants';
import CustomModal from './CustomModal';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, Modifier, convertFromHTML, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { toast } from 'react-toastify';
import { callApi } from '../lib/api/callApi';
import CompanyAutocomplete from './CompanyAutocomplete';
import { getPermissionForComponent } from '../utils/permissionsUtils';

class AddCompanyForm extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.token = localStorage.getItem('jwtToken');
    this.state = {
      name: '',
      errors: {},
      address1: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.address1 ?? '' : '',
      address2: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.address2 ?? '' : '',
      city: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.city ?? '' : '',
      state: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.state ?? '' : '',
      zip: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.zip ?? '' : '',
      companyGroupName:
      props.comingFrom === 'edit' &&
      Array.isArray(props.editData?.companyGroups) &&
      props.editData?.companyGroups?.length > 0
        ? props?.editData?.companyGroups[0]?.name || ''
        : '',
      productGroupTemplate:
        props.comingFrom === 'edit' ? props?.editData?.productGroupTemplate?.templateName : '',
      templateId: '',
      companyId: props.comingFrom === 'edit' ? props.editData._id : null,
      epikCustomerId: props.comingFrom === 'edit' ? props.editData.epikCustomerId : '',
      selectType:
        props.comingFrom === 'edit'
          ? this.getCompanyType(props.editData.companyType)
          : COMPANY_TYPE_DROPDOWN[0],
      name: props.comingFrom === 'edit' ? props.editData.name : props.name,
      status: props.comingFrom === 'edit' ? props.editData.enabled : props.status,
      oobmTerminalEmulator: props.comingFrom === 'edit' ? props.editData.oobmTerminalEmulator : false,
      permissions: {
        emailNotifications:
          props.comingFrom === 'edit' ? props.editPermissions.emailNotifications : false,
        showCallRecording:
          props.comingFrom === 'edit' ? props.editPermissions.showCallRecording : false,
        showFaxDownload:
          props.comingFrom === 'edit' ? props.editPermissions.showFaxDownload : false,
      },
      contactPerson: {
        email: '',
        name: '',
        phone: '',
      },
      contactEmails: props.comingFrom === 'edit' ? props.editData.contactEmails : [],
      configureSecurityBanner: false,
      editorState: EditorState.createEmpty(),
      loginSecurityBanner: {
        enabled: false,
        title: '',
        text: ''
      },
      companyGroupNames: [],
      isCompanyGroupsLoading: false,
    };
    this.onEnabledChange = this.onEnabledChange.bind(this);
  }
  handleChange = ev => {
    let name, value;
    if (ev?.target) {
        ({ name, value } = ev.target);
    } else {
        name = 'companyGroups';
        value = ev?.suggestion?._id;
    }

    this.setState(prevState => ({
        [name]: value,
        errors: {
            ...prevState.errors,
            [name]: ''
        }
    }));
    this.onAddedCompanyChange({ target: { name, value } });
  };
  handleCompanyGroupChange = ev => {
    if (this.state.isCompanyGroupsLoading) return;
    this.handleChange(ev);
  };

  handleSubmit = async () => {
    const errors = {};
    if (this.state.name === '' || this.state.name == undefined) {
      errors.name = COMPANY_MODAL.COMPANY_NAME
    }
    console.log('errors', errors);

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    // Call the onConfirm function passed from the parent if no errors
    this.props.onConfirm();
  };

  getCompanyType = e => {
    const selectedType = COMPANY_TYPE_DROPDOWN.filter(item => item.value === e);
    return selectedType[0];
  };

  componentDidMount() {
    const { comingFrom, editData, editPermissions, getTemplates } = this.props;
    const { contactPerson, permissions, loginSecurityBanner } = this.state;
    this.getCompanyGroupNames();
    getTemplates(this.token, 'productGroup');
    this.props.addCompanyChange({
      name: 'companyType',
      value: COMPANY_TYPE_DROPDOWN[0].value,
    });
    if (comingFrom === 'edit') {
      this.props.addCompanyChange({
        name: 'showFaxDownload',
        value: editPermissions.showFaxDownload,
      });
      this.props.addCompanyChange({
        name: 'emailNotifications',
        value: editPermissions.emailNotifications,
      });
      this.props.addCompanyChange({
        name: 'showCallRecording',
        value: editPermissions.showCallRecording,
      });
      this.props.addCompanyChange({
        name: 'oobmTerminalEmulator',
        value: editData?.oobmTerminalEmulator ? editData?.oobmTerminalEmulator : false
      });
      this.props.addCompanyChange({
        name: 'enabled',
        value: editData?.loginSecurityBanner?.enabled,
        type: 'loginSecurityBanner'
      });
      this.props.addCompanyChange({
        name: 'title',
        value: editData?.loginSecurityBanner?.title,
        type: 'loginSecurityBanner'
      });
      const grp = this.props.editData?.companyGroups?.[0];
      if (grp?._id) {
        this.props.addCompanyChange({ name: 'companyGroups', value: grp._id });
      }

      const savedHTMLContent = editData?.loginSecurityBanner?.text;

      this.props.addCompanyChange({
        name: 'text',
        value: savedHTMLContent,
        type: 'loginSecurityBanner'
      });

      if (savedHTMLContent) {
        const contentBlock = htmlToDraft(savedHTMLContent);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          this.setState({ editorState: EditorState.createWithContent(contentState) });
        }
      }

      loginSecurityBanner['enabled'] = editData?.loginSecurityBanner?.enabled || false;
      loginSecurityBanner['title'] = editData?.loginSecurityBanner?.title || '';
      loginSecurityBanner['text'] = editData?.loginSecurityBanner?.text || '';
      permissions.showFaxDownload = editPermissions.showFaxDownload;
      permissions.emailNotifications = editPermissions.emailNotifications;
      permissions.showCallRecording = editPermissions.showCallRecording;
      this.props.addCompanyChange({
        name: 'name',
        value: editData?.contactPerson?.name || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'email',
        value: editData?.contactPerson?.email || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'phone',
        value: editData?.contactPerson?.phone || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'contactEmails',
        value: editData?.contactEmails || [],
      });
      contactPerson['name'] = editData?.contactPerson?.name || '';
      contactPerson['email'] = editData?.contactPerson?.email || '';
      contactPerson['phone'] = editData?.contactPerson?.phone || '';
      this.props.addCompanyChange({
        name: 'address1',
        value: editData?.companyLocation?.address1 || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'address2',
        value: editData?.companyLocation?.address2 || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'zip',
        value: editData?.companyLocation?.zip || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'state',
        value: editData?.companyLocation?.state || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'city',
        value: editData?.companyLocation?.city || '',
        type: 'companyLocation',
      });
      this.setState({ contactPerson, permissions });
    }
  }

  onAddedCompanyChange = ev => {
    console.log('jah',ev.target);

    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyChange({ name, value });
  };
  onAddCompanyLocation = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyChange({ name, value, type: 'companyLocation' });
  };

  onContactPersonChange = ev => {
    const { name, value } = ev.target;
    const { contactPerson } = this.state;
    contactPerson[name] = value;
    this.setState({ contactPerson });
    this.props.addCompanyChange({ name, value, type: 'contactPerson' });
  };

  onEnabledChange(value) {
    this.props.addCompanyChange({ name: 'enabled', value: !value });
    this.setState({ status: !value });
  }
  onOobmEnabledChange(value) {
    this.props.addCompanyChange({ name: 'oobmTerminalEmulator', value: !value });
    this.setState({ oobmTerminalEmulator: !value });
  }

  onFaxDownloadChange = value => {
    this.props.addCompanyChange({ name: 'showFaxDownload', value: !value });
    const { permissions } = this.state;
    permissions.showFaxDownload = !value;
    this.setState({ permissions });
    if (!value) {
      // If the Fax Download Option is being enabled, open the modal
      this.toggleAlertModal();
    }
  };
  toggleAlertModal = () => {
    this.setState((prevState) => ({
      isAlertModalOpen: !prevState.isAlertModalOpen,
    }));
  };

  onEnabledNotificationChange = value => {
    this.props.addCompanyChange({ name: 'emailNotifications', value: !value });
    const { permissions } = this.state;
    permissions.emailNotifications = !value;
    this.setState({ permissions });
  };

  onEnabledCallRecordings = value => {
    this.props.addCompanyChange({ name: 'showCallRecording', value: !value });
    const { permissions } = this.state;
    permissions.showCallRecording = !value;
    this.setState({ permissions });
  };

  onTypeSelect = selectedOption => {
    const { value } = selectedOption;
    this.setState({ selectType: selectedOption });
    this.props.addCompanyChange({ name: 'companyType', value });
  };

  onEmailsChange(emails) {
    const { addCompanyChange } = this.props;
    const target = {
      name: 'contactEmails',
      value: emails,
    };
    this.setState(
      {
        contactEmails: emails,
      },
      () => {
        addCompanyChange(target);
      },
    );
  }

  getLocationInfo = ev => {
    const propertyNames = ['address', 'address2', 'zip', 'state', 'city', 'country'];

    propertyNames.forEach((name) => {
      this.props.addCompanyChange({
        name: name === 'address' ? 'address1' : name,
        value: ev?.[name] || '',
        type: 'companyLocation',
      });
    });
  }

  getCompanyGroupNames = async () => {
    this.setState({ isCompanyGroupsLoading: true });
    try {
      const endpoint = `companyGroups?paginateResult=false&getDeleted=false&onlyName=true`;
      const response = await callApi({
        endpoint,
        method: 'GET',
        isMyEpik: true
      });
      this.setState({ companyGroupNames: response?.data?.docs || [] });
    } catch (e) {
      this.setState({ companyGroupNames: [] });
    } finally {
      this.setState({ isCompanyGroupsLoading: false });
    }
  }

  onSecurityBannerChange = (value, name) => {
    const newVal = name === 'enabled' ? !value : value;
    
    this.props.addCompanyChange({ name, value: newVal, type: 'loginSecurityBanner' });
    const { loginSecurityBanner } = this.state;
    loginSecurityBanner[name] = newVal;
    this.setState({ loginSecurityBanner });
  };

  validateEditorContent = () => {
    const contentState = this.state.editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);

    // Check if all blocks are empty
    const hasMeaningfulContent = rawContent.blocks.some(
      (block) => block.text.trim() !== '' // Checks if any block has text
    );

    return hasMeaningfulContent;
  }

  onConfigureSecurityBanner = () => {
    const isValid = this.validateEditorContent();

    if (!isValid) {
      toast.error('Editor content is empty. Please enter some text.');
      return;
    }

    this.setState({ configureSecurityBanner: false })
  }

  onCancelSecurityBanner = () => {
    const { addCompanyChange, comingFrom } = this.props;
    const { loginSecurityBanner } = this.state;

    if (comingFrom !== 'edit') {
      addCompanyChange({ name: 'enabled', value: false, type: 'loginSecurityBanner' });
      addCompanyChange({ name: 'title', value: '', type: 'loginSecurityBanner' });
      addCompanyChange({ name: 'text', value: '', type: 'loginSecurityBanner' });
  
      loginSecurityBanner.enabled = false;
      loginSecurityBanner.title = '';
      loginSecurityBanner.text = '';
    }

    this.setState({ configureSecurityBanner: false, loginSecurityBanner })
  }

  onEditorStateChange = (e) => {
    console.log('something happening.', e);
    this.setState({ editorState: e })

    const htmlText = draftToHtml(convertToRaw(this.state.editorState?.getCurrentContent()));

    this.props.addCompanyChange({ name: 'text', value: htmlText, type: 'loginSecurityBanner' });
    const { loginSecurityBanner } = this.state;
    loginSecurityBanner.text = htmlText;
    this.setState({ loginSecurityBanner });
  }

  sanitizeHTML = (html) => {
    return html
      .replace(/&nbsp;/g, ' ') 
      .replace(/\s\s+/g, ' ')  
      .trim(); 
  };

  handlePastedText = (text, html, editorState) => {
    if (html) {
      const cleanedHTML = this.sanitizeHTML(html);

      const blocksFromHTML = convertFromHTML(cleanedHTML);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      this.setState({ editorState: EditorState.push(editorState, contentState, 'insert-fragment') });
      return true;
    }

    const newContent = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      text
    );
    this.setState({ editorState: EditorState.push(editorState, newContent, 'insert-characters') });
    return true; 
  };

  render() {
    const disableOobmTerminal = getPermissionForComponent('disableOobmTerminal', this.props?.user?.permissionsGroup);
    const canDisableOobmTerminal = disableOobmTerminal === 'write' || disableOobmTerminal === 'both' || this.props?.user?.role == "companyGroupAdmin";
    const { isAlertModalOpen, companyGroupNames } = this.state;
    const { role : userRole } = this.props?.user
    const formData = {
      city: this.state?.city || '',
      state: this.state?.state || '',
      address1: this.state?.address1 || '',
      address2: this.state?.address2 || '',
      zip: this.state?.zip || '',
    }

    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={6}>
            Granite Parent Account:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="epikCustomerId"
              value={this.state.epikCustomerId}
              onChange={this.onAddedCompanyChange}
              id="epik-customer-Id"
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={4}>
            Company Name:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="name"
              value={this.state.name}
              onChange={this.handleChange}
              id="company-name"
            />
            {this.state.errors.name && (
              <div className="text-danger">{this.state.errors.name}</div> // Show validation error
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
            <Label for="name" sm={6}>
              Management Group:
            </Label>
            <Col sm={12}>
              <CompanyAutocomplete
              key={`mg-${this.state.isCompanyGroupsLoading}-${companyGroupNames.length}`}
              placeholder="Please Specify"
              companies={ this.state.isCompanyGroupsLoading ? [{ _id: '__loading__', name: 'Loading...' }] : companyGroupNames }
                onChange={this.handleCompanyGroupChange}
                searchTerm={this.state.companyGroupName || ''}
              />
            </Col>
        </FormGroup>
        <Location
          disabled={false}
          boxDbLocation={this.props.comingFrom === 'edit' ? formData: ''}
          getLocationInfo={this.getLocationInfo}
          latLang={false}
          address2={true}
        />
        {/* <FormGroup row>
          <Label for="name" sm={4}>
            Address 1:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="address1"
              value={this.state.address1}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Address 2:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="address2"
              value={this.state.address2}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            City:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="city"
              value={this.state.city}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={4}>
            State :
          </Label>
          <Col sm={12}>
            <Input
              required
              type="select"
              name="state"
              value={this.state.state}
              onChange={this.onAddCompanyLocation}
            ><option value="" hidden>Please specify</option>
              {
                STATE_OPTIONS.map(({ label, value }) => {
                  return <option value={value}> {label}</option>;
                })
              }
            </Input>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Zip :
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="zip"
              value={this.state.zip}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup> */}
        <FormGroup row>
          <Label sm={4}>Type:</Label>
          <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <DropdownSelect
              options={COMPANY_TYPE_DROPDOWN}
              selectedOption={this.state.selectType}
              onSelect={this.onTypeSelect}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={12}>
            Contact Person Name:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="name"
              value={this.state.contactPerson.name}
              onChange={this.onContactPersonChange}
              id="contact-person-name"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Email:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="email"
              value={this.state.contactPerson.email}
              onChange={this.onContactPersonChange}
              id="company-email"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Phone Number:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="number"
              name="phone"
              value={this.state.contactPerson.phone}
              onChange={this.onContactPersonChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Select template:
          </Label>
          <Col sm={12}>
            <TemplateAutoComplete
              searchTerm={this.state.productGroupTemplate}
              templates={this.props.productGroupTemplate}
              onChange={e =>
                e.suggestion !== null
                  ? this.props.addCompanyChange({
                    name: 'productGroupTemplate',
                    value: e.suggestion._id,
                  })
                  : ''
              }
            />
          </Col>
        </FormGroup>
        <Row>
          <Col sm={6}>
            <FormGroup row>
              <Label for="enabled" sm={4}>
                Status:
              </Label>
              <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle value={this.state.status} onToggle={this.onEnabledChange} />
              </Col>
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup row>
              <Label for="enabled" sm={12}>
                Fax Download Option:
              </Label>
              <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle
                  value={this.state.permissions.showFaxDownload}
                  onToggle={this.onFaxDownloadChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <AlertFaxDownloadModal
            isOpen={isAlertModalOpen}
            onConfirm={() => {
              this.toggleAlertModal(); // Close the modal
            }}
            title="Attention!"
            body="Enabling the Fax Download Option will allow the customer to download any faxes sent on t.37 fax lines. This should not be enabled for customers that need to be HIPAA compliant."
          />

        </Row>

        <Row>
          <Col sm={6}>
            <FormGroup row>
              <Label for="emailNotifications" sm={12}>
                Email Notifications:
              </Label>
              <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle
                  value={this.state.permissions.emailNotifications}
                  onToggle={this.onEnabledNotificationChange}
                />
              </Col>
          </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup row>
              <Label for="enabled" sm={12}>
                Login Security Banner:
              </Label>
              <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle
                  value={this.state?.loginSecurityBanner?.enabled}
                  onToggle={() => this.onSecurityBannerChange(this.state?.loginSecurityBanner?.enabled, 'enabled')}
                />
                {this.state?.loginSecurityBanner?.enabled && (
                  <div style={{ marginLeft: '10px' }}>
                    <a href='#' onClick={() => this.setState({ configureSecurityBanner: true })}>Configure</a>
                  </div>
                )}
              </Col>
          </FormGroup>
          </Col>
        </Row>

      <Row>
     <Col sm={6}>
        <FormGroup row>
         <Label for="showCallRecording" sm={12}>
            Show Call Recording:
         </Label>
         <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
           <Toggle
             value={this.state.permissions.showCallRecording}
             onToggle={this.onEnabledCallRecordings}
           />
         </Col>
       </FormGroup>
          </Col>
          {canDisableOobmTerminal && (
            <Col sm={6}>
              <FormGroup row>
                <Label sm={12}>
                  Disable OOBM Portal Terminal Emulator:
                </Label>
                <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={this.state.oobmTerminalEmulator}
                    onToggle={this.onOobmEnabledChange.bind(this)}
                  />
                </Col>
              </FormGroup>
            </Col>
          )}
        </Row>
        <FormGroup row>
          <Col sm={12}>
            <hr />
          </Col>
          <Label for="AlertContacts" sm={6}>
            Alert Contacts:
          </Label>
          <Col sm={12}>
            <MultiInput
              placeholder="Enter the email"
              inputData={this.state.contactEmails}
              onChange={this.onEmailsChange.bind(this)}
              validator={util.validateEmail}
            />
          </Col>
        </FormGroup>
      <CustomModal
        isOpen={this.state?.configureSecurityBanner}
        header={'Configure Security Banner'}
        onSave={() => this.onConfigureSecurityBanner()}
        onCancel={() => this.onCancelSecurityBanner()}
        saveBtnText={'Save'}
        customBodyClass={'security-banner'}
        medium
      >
        <Row>
          <Col sm={12}>
            <p style={{ fontSize: '0.9rem' }}>The following text will be shown at User Login for this Company with an acknowledgement button.</p>
          </Col>
        </Row>
        <Row>
          <Label for="AlertContacts" sm={6}>
            <strong>Title:</strong>
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              type="text"
              value={this.state?.loginSecurityBanner?.title}
              onChange={(e) => this.onSecurityBannerChange(e?.target?.value, 'title')}
            />
          </Col>
        </Row>
        <Row>
          <Label for="AlertContacts" sm={6}>
            <strong>Body:</strong>
          </Label>
          <Col md={12}>
            <Editor
              editorState={this.state?.editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editor-class"
              onEditorStateChange={(e) => this.onEditorStateChange(e)}
              handlePastedText={(text, html) => this.handlePastedText(text, html, this.state?.editorState)}
              toolbar={{
                options: [
                  'inline',
                  'blockType',
                  'fontSize',
                  'fontFamily',
                  'list',
                  'textAlign',
                  'colorPicker',
                  'link',
                  'emoji',
                  'remove',
                  'history',
                ],
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
              }}
            />
          </Col>
        </Row>
      </CustomModal>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    name: state.UIState.companies.addedCompany.name,
    status: state.UIState.companies.addedCompany.enabled,
    editData: state.UIState.companies.editCompanyData,
    editPermissions: state.UIState.companies.editCompanyData.permissions || '',
    productGroupTemplate: state.AppState.modifyProducts.productGroupTemplate,
    user: state.AppState.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCompanyChange: companyData => dispatch(addCompanyChange(companyData)),
    getTemplates: (token, type) => dispatch(getTemplates(token, type)),
  };
};

const AddCompanyFormWithRef = forwardRef((props, ref) => (
  <AddCompanyForm {...props} ref={ref} />
));

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(AddCompanyFormWithRef);